import { vToday } from './view.js';
import { actions } from './actions.js';

export default { id: 'today', label: 'Today', icon: 'today', nav: true, show: () => true, view: vToday, actions };
